import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorService } from '../services/error.service';
import { SUPPRESS_HTTP_ERROR_TOAST } from './http-context';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorService = inject(ErrorService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Callers that recover from a failure themselves (see SUPPRESS_HTTP_ERROR_TOAST)
      // opt out of the toast; the error is still propagated to them.
      if (!req.context.get(SUPPRESS_HTTP_ERROR_TOAST)) {
        errorService.httpErrorResponseToast(error);
      }

      return throwError(() => error);
    }),
  );
};
